<template>
  <div class="analysis-studio-top-bar">
    <!--  menu activation button -->
    <!-- <icon type="button">menu</icon> -->
    <icon type="button" @click="$router.push('/dashboards')">arrow_back</icon>

    <!-- title section -->
    <div class="analysis-title">
      <icon>bar_chart</icon>
      <div class="texts">
        <h3>Supply Demand Gap</h3>
      </div>
    </div>

    <!-- City selection -->
    <!-- <div class="city-selection">
      <icon size="18" class="city_indicator">location_on</icon>
      <div class="text-holder">
        <h3>Bangalore</h3>
      </div>
      <icon size="18">search</icon>
    </div> -->

    <CityFilter
      @click="$emit('toggleSearch')"
      placeholder="Select City"
      v-model="selectedCity"
      class="cityFilterOverride"
    />
    <!-- Tools area -->
    <div class="tools-area">
      <div class="context-switch">
        <button
          :class="['toggle-button', { active: !showStats }]"
          @click="$emit('showMap')"
        >
          <icon size="18" @click="$emit('showMap')">map</icon>
          Map View
        </button>
        <button
          :class="['toggle-button', { active: showStats }]"
          @click="$emit('showStats')"
        >
          <icon size="18" @click="$emit('showStats')">table_chart</icon>
          Statistic View
        </button>
      </div>
      <!-- <ToolsList /> -->
    </div>

    <!-- <expand /> -->
    <!-- <Button
      v-if="getMode === 'EDIT'"
      type="primary"
      icon="save"
      text="Save Console"
      @click="saveConsole"
    />
    <Button
      v-else-if="getMode === 'VIEW'"
      type="primary"
      icon="edit"
      text="Edit Console"
      @click="openEditMode"
    /> -->
  </div>
</template>

<script>
import ToolsList from "@/components/static_entity_analysis/views/ToolsList";
import Button from "@/components/global/views/Button";
import CityFilter from "@/components/entities/views/CityFilter";
import Chits from "@/components/static_entity_analysis/views/chits";
import { mapGetters, mapActions } from "vuex";
import { trackConsoleSave } from "@/lib/analytics";

export default {
  props: {
    showStats: Boolean,
  },
  components: {
    ToolsList,
    Button,
    CityFilter,
  },
  data() {
    return {
      selectedCity: null,
    };
  },
  computed: {
    ...mapGetters("Location", [
      "getCities",
      "getFetchingCities",
      "getActiveCity",
    ]),
    ...mapGetters("StaticEntity", [
      "getMode",
      "getCurrentStaticEntity",
      "getAppliedFilters",
    ]),
    ...mapGetters("Entities", ["getStaticEntitiesById"]),
  },
  methods: {
    // ...mapActions("StaticEntity", ["setActiveCity"]),
    ...mapActions("StaticEntity", [
      "refetchAllData",
      "createPayloadForSaving",
      "reset",
      "initializeConsole",
      "setMode",
      "toggleEntityFilter",
    ]),
    ...mapActions("Location", ["setActiveCity"]),
  },
  watch: {
    selectedCity(city) {
      this.setActiveCity(city);
      // this.refetchAllData();
    },
    getActiveCity: {
      immediate: true,
      handler(city) {
        if (this.selectedCity !== city) this.selectedCity = city;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis-studio-top-bar {
  display: flex;
  height: 60px;
  max-height: 60px;
  background: var(--color-secondary);
  flex-direction: row;
  align-items: center;
  padding: 0 15px 0 10px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.15);
  z-index: 100;
  .analysis-title {
    display: flex;
    flex-direction: row;
    align-items: center;

    i {
      background: var(--color-primary-light);
      padding: 10px;
      border-radius: 50%;
      margin-left: 10px;
      color: var(--color-primary);
    }

    .texts {
      margin-left: 10px;

      h3 {
        font-weight: bold;
      }
    }
  }

  .city-selection {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 20px;
    border-left: 1px solid var(--border-color);
    border-right: 1px solid var(--border-color);
    margin-left: 20px;
    border-radius: 5px;
    transition: 0.3s all ease-in-out;
    background: var(--color-secondary-light);

    .city_indicator {
      margin-right: 7px;
    }

    .text-holder {
      display: flex;
      flex-direction: column;
      width: 150px;
    }

    label {
      font-size: 0.8em;
    }

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }

  .cityFilterOverride {
    margin-left: 20px;
    /* .filter-header {
      p.selected {
        color: red;
        padding: 10px 15px 10px 15px !important;
      }
    } */
  }

  .tools-area {
    display: flex;
    flex-direction: row;
    align-items: center;

    .context-switch {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0 15px 0 0;
      padding: 0 15px;
      border-right: 1px solid var(--border-color);

      /* i {
        padding: 10px;
        border-radius: 50%;
        transition: 0.1s all ease-in-out;

        &:hover {
          background: var(--color-secondary-light);
          cursor: pointer;
        }

        &:active {
          transform: scale(0.9);
        }

        &.active {
          background: var(--color-primary-light);
          color: var(--color-primary);
        }

        &:first-child {
          margin-right: 5px;
        }
      } */

      .toggle-button {
        border: 0;
        padding: 10px 15px;
        color: var(--font-color);
        border-radius: 5px;
        outline: none;
        transition: 0.3s all ease-in-out;
        white-space: nowrap;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--color-transparent);

        i {
          margin: 0 5px 0 0;
        }

        &:hover {
          cursor: pointer;
          background: var(--color-secondary-light);
        }

        &.active {
          color: var(--color-primary);
          background: var(--color-primary-light);
        }

        &:active {
          transform: scale(0.95);
        }

        &:first-child {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
